import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-nma',
  templateUrl: './nma.component.html',
  styleUrls: ['./nma.component.scss']
})
export class NmaComponent implements OnInit {

  exposition: CardContent = {
    title: 'Network Meta Analysis',
    subtitle: 'Integrating the results of multiple clinical studies',
    image_source: 'assets/images/Rankogramm.PNG',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Clients</h4>MArS, Adelphi&nbsp;Values',
      '<h4>Methods</h4>Data Science, Bayesian&nbsp;Inference',
      '<h4>Technology / Skills</h4>R, WinBUGS',
      '<h4>Term</h4>2016',
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
